module.exports = __webpack_public_path__ + "img/path.7e2d1c13.png";